import { UtensilsCrossed, MapPin, Clock, Calendar } from "lucide-react";

// Well Street Kitchen — Hackney · Appetite-led, vibrant
export default function WellStreetAfter({ b }) {
  return (
    <div className="bg-[#FAF5E9] text-[#2C3E50]">
      <div className="px-6 md:px-10 py-4 flex items-center justify-between border-b border-[#2C3E50]/10">
        <div className="font-outfit font-extrabold text-xl tracking-tight">Well Street <span className="text-[#D35400]">Kitchen.</span></div>
        <nav className="hidden md:flex gap-6 text-xs uppercase tracking-[0.15em] font-outfit font-medium text-[#2C3E50]/80">
          <span>Menu</span><span>Brunch Club</span><span>Press</span><span>Book a table</span>
        </nav>
        <button className="bg-[#D35400] text-[#FAF5E9] px-4 py-2 text-xs uppercase tracking-[0.2em] font-outfit font-bold">Reserve</button>
      </div>

      {/* Hero */}
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-[500px]">
        <div className="px-6 md:px-12 py-16 md:py-24 flex flex-col justify-center">
          <p className="font-outfit font-medium uppercase tracking-[0.3em] text-[10px] text-[#D35400] mb-6">203 WELL ST · E9 · 4.7★ · 683 reviews</p>
          <h1 className="font-outfit font-extrabold text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
            Brunch worth<br/>
            <span className="text-[#D35400]">leaving Hackney</span><br/>
            for. (Don't.)
          </h1>
          <p className="mt-8 max-w-md text-lg leading-relaxed text-[#2C3E50]/80">
            Hot sourdough sandwiches, all-day eggs, slow-roasted weekends — and 683 reviewers who already agree.
            Now with proper bookings, finally.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <button className="bg-[#D35400] text-[#FAF5E9] px-7 py-4 font-outfit font-bold uppercase tracking-[0.15em] text-sm hover:bg-[#2C3E50] transition-colors flex items-center gap-2">
              <Calendar className="w-4 h-4" /> Book a table
            </button>
            <button className="border-2 border-[#2C3E50] px-7 py-4 font-outfit font-bold uppercase tracking-[0.15em] text-sm">See the menu</button>
          </div>
        </div>
        <div
          className="bg-cover bg-center min-h-[400px]"
          style={{ backgroundImage: "url(https://images.unsplash.com/photo-1560055932-595dab110124)" }}
        />
      </div>

      {/* Menu highlights */}
      <div className="border-y-2 border-[#2C3E50]/15 bg-[#F2EAD3]">
        <div className="px-6 md:px-10 py-14">
          <p className="font-outfit font-medium uppercase tracking-[0.3em] text-[10px] text-[#D35400] mb-3">THIS WEEK</p>
          <h2 className="font-outfit font-extrabold text-4xl md:text-5xl mb-10">Hot off the pass.</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              ["Confit egg, brown butter, sourdough", "£11", "Brunch / V"],
              ["Slow-braised lamb shoulder bao", "£14", "Lunch"],
              ["Burnt Basque cheesecake", "£8", "Pud"],
            ].map(([n, p, t]) => (
              <div key={n} className="bg-[#FAF5E9] border-2 border-[#2C3E50] p-6 hover:bg-[#D35400] hover:text-[#FAF5E9] transition-colors group">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="font-outfit font-bold text-xl leading-tight">{n}</div>
                    <div className="font-outfit text-xs uppercase tracking-[0.2em] text-[#D35400] group-hover:text-[#FAF5E9] mt-3">{t}</div>
                  </div>
                  <div className="font-outfit font-extrabold text-2xl">{p}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Press wall */}
      <div className="px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-4">
          <p className="font-outfit font-medium uppercase tracking-[0.3em] text-[10px] text-[#D35400] mb-3">PRESS</p>
          <h3 className="font-outfit font-extrabold text-4xl leading-tight">683 reviewers can't be wrong.</h3>
        </div>
        <div className="md:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            ["“The eggs alone are worth the bus from Dalston.”", "— Hackney Gazette"],
            ["“A Well Street institution in waiting.”", "— Time Out London"],
            ["“Best brunch in E9, full stop.”", "— Google · 5★"],
            ["“We've been every Saturday for two years.”", "— Local regular"],
          ].map(([q, a], i) => (
            <div key={i} className="border-l-4 border-[#D35400] pl-4 py-2">
              <p className="font-outfit text-lg leading-tight">{q}</p>
              <p className="font-outfit text-xs uppercase tracking-[0.2em] text-[#D35400] mt-2">{a}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Visit */}
      <div className="bg-[#2C3E50] text-[#FAF5E9] px-6 md:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
        <p className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#D35400]" /> {b.address}</p>
        <p className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#D35400]" /> Tue–Sun · 8am–4pm</p>
        <p className="flex items-center gap-2"><UtensilsCrossed className="w-4 h-4 text-[#D35400]" /> Walk-ins held until 12:30pm</p>
      </div>
    </div>
  );
}
